"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefiWireType = exports.UNKNOWN_LENDER_NAME = exports.PriorLienLoanType = exports.PriorLienStatus = exports.LienRefiThirdPartyLenderWireReferenceType = exports.RefiType = exports.BorrowerAuthSignatureMethod = exports.RefiStageForFrontend = exports.SERVICER_NAME_MAX_LENGTH = exports.BORROWER_ACCOUNT_NUMBER_PATTERN = exports.PayoffQuoteAcquisitionProvider = void 0;
// Who gets a lien refi's payoff quote. Stewart orders it from the lender itself, so the borrower is never asked for one.
var PayoffQuoteAcquisitionProvider;
(function (PayoffQuoteAcquisitionProvider) {
    PayoffQuoteAcquisitionProvider["Aven"] = "Aven";
    PayoffQuoteAcquisitionProvider["Fidelity"] = "Fidelity";
    PayoffQuoteAcquisitionProvider["DocSolutions"] = "DocSolutions";
    PayoffQuoteAcquisitionProvider["Stewart"] = "Stewart";
})(PayoffQuoteAcquisitionProvider || (exports.PayoffQuoteAcquisitionProvider = PayoffQuoteAcquisitionProvider = {}));
// A prior lender's loan or account number as a borrower types it from their statement
exports.BORROWER_ACCOUNT_NUMBER_PATTERN = /^[A-Za-z0-9 -]{4,40}$/;
exports.SERVICER_NAME_MAX_LENGTH = 100;
/* @TranslateToPython */
var RefiStageForFrontend;
(function (RefiStageForFrontend) {
    RefiStageForFrontend["SEND_CARD"] = "SEND_CARD";
    RefiStageForFrontend["UPLOAD_STATEMENT"] = "UPLOAD_STATEMENT";
    RefiStageForFrontend["REVIEW_STATEMENT"] = "REVIEW_STATEMENT";
    RefiStageForFrontend["TRANSFER_FUNDS"] = "TRANSFER_FUNDS";
    RefiStageForFrontend["PREPARING_BORROWER_AUTH"] = "PREPARING_BORROWER_AUTH";
    RefiStageForFrontend["REQUIRE_BORROWER_AUTH_WET_SIGNED_DOC"] = "REQUIRE_BORROWER_AUTH_WET_SIGNED_DOC";
    RefiStageForFrontend["REQUIRE_BORROWER_AUTH_SIGNED_DOC"] = "REQUIRE_BORROWER_AUTH_SIGNED_DOC";
    RefiStageForFrontend["REQUEST_PAYOFF_QUOTE"] = "REQUEST_PAYOFF_QUOTE";
    RefiStageForFrontend["SEND_PAYOFF"] = "SEND_PAYOFF";
    RefiStageForFrontend["COMPLETE_PAYOFF"] = "COMPLETE_PAYOFF";
    RefiStageForFrontend["ACTIVATE_ACCOUNT"] = "ACTIVATE_ACCOUNT";
    RefiStageForFrontend["CANCELLED"] = "CANCELLED";
})(RefiStageForFrontend || (exports.RefiStageForFrontend = RefiStageForFrontend = {}));
/** How the borrower signs a lien's borrower authorization: e-sign in the portal, or print, wet sign and upload. */
var BorrowerAuthSignatureMethod;
(function (BorrowerAuthSignatureMethod) {
    BorrowerAuthSignatureMethod["eSign"] = "eSign";
    BorrowerAuthSignatureMethod["wetSign"] = "wetSign";
})(BorrowerAuthSignatureMethod || (exports.BorrowerAuthSignatureMethod = BorrowerAuthSignatureMethod = {}));
/* @TranslateToPython */
var RefiType;
(function (RefiType) {
    RefiType["FIRST"] = "FIRST";
    RefiType["SECOND"] = "SECOND";
    RefiType["MULTI"] = "MULTI";
    RefiType["NONE"] = "NONE";
})(RefiType || (exports.RefiType = RefiType = {}));
// Templates for constructing wire reference
var LienRefiThirdPartyLenderWireReferenceType;
(function (LienRefiThirdPartyLenderWireReferenceType) {
    LienRefiThirdPartyLenderWireReferenceType["LenderLoanIdBorrowerNamePropertyAddress"] = "LenderLoanIdBorrowerNamePropertyAddress";
    LienRefiThirdPartyLenderWireReferenceType["AvenLoanIdBorrowerNamePropertyAddress"] = "AvenLoanIdBorrowerNamePropertyAddress";
    LienRefiThirdPartyLenderWireReferenceType["BorrowerNamePropertyAddress"] = "BorrowerNamePropertyAddress";
})(LienRefiThirdPartyLenderWireReferenceType || (exports.LienRefiThirdPartyLenderWireReferenceType = LienRefiThirdPartyLenderWireReferenceType = {}));
var PriorLienStatus;
(function (PriorLienStatus) {
    // Either detected from provider data source or attested by user
    PriorLienStatus["DETECTED"] = "DETECTED";
    // We've confirmed that this lien is present
    PriorLienStatus["CONFIRMED"] = "CONFIRMED";
    // The lien has been released through refi process
    PriorLienStatus["RELEASED"] = "RELEASED";
    // The lien does not exist, duplicate, or wrong information
    PriorLienStatus["NON_EXISTENT"] = "NON_EXISTENT";
})(PriorLienStatus || (exports.PriorLienStatus = PriorLienStatus = {}));
var PriorLienLoanType;
(function (PriorLienLoanType) {
    PriorLienLoanType["HELOC"] = "HELOC";
    PriorLienLoanType["HELOAN"] = "HELOAN";
    PriorLienLoanType["MORTGAGE"] = "MORTGAGE";
    PriorLienLoanType["OTHER"] = "OTHER";
})(PriorLienLoanType || (exports.PriorLienLoanType = PriorLienLoanType = {}));
exports.UNKNOWN_LENDER_NAME = 'your existing lender';
var RefiWireType;
(function (RefiWireType) {
    RefiWireType["FED_WIRE"] = "FED_WIRE";
    RefiWireType["MANUAL_CHECK"] = "MANUAL_CHECK";
})(RefiWireType || (exports.RefiWireType = RefiWireType = {}));
